import moment from 'moment'
import { FC } from 'react'
import { useCountdown } from '../hooks'
import { Clock } from '../primitives'

export const Countdown: FC<{ until: moment.Moment }> = ({ until }) => {
  const { diff } = useCountdown(until)

  return (
    <Clock.Root>
      <Clock.NumberContainer>
        <Clock.Number>{diff?.days}</Clock.Number>
        <Clock.Label>Days</Clock.Label>
      </Clock.NumberContainer>

      <Clock.Number>:</Clock.Number>

      <Clock.NumberContainer>
        <Clock.Number>{diff?.hours}</Clock.Number>
        <Clock.Label>Hours</Clock.Label>
      </Clock.NumberContainer>

      <Clock.Number>:</Clock.Number>

      <Clock.NumberContainer>
        <Clock.Number>{diff?.minutes}</Clock.Number>
        <Clock.Label>Minutes</Clock.Label>
      </Clock.NumberContainer>

      <Clock.Number>:</Clock.Number>

      <Clock.NumberContainer>
        <Clock.Number>{diff?.seconds}</Clock.Number>
        <Clock.Label>Seconds</Clock.Label>
      </Clock.NumberContainer>
    </Clock.Root>
  )
}
